import React, { ReactElement } from 'react';
import { Tooltip as MuiTooltip, TooltipProps as MuiTooltipProps } from '@mui/material';

export interface TooltipProps extends MuiTooltipProps {
  children: ReactElement<any, any>;
}

const Tooltip: React.FC<TooltipProps> = ({ children, ...rest }) => (
  <MuiTooltip {...rest}>{children}</MuiTooltip>
);

export default Tooltip;
